import React from 'react'
import styled from 'styled-components'
import ImageComponentHead from '../../../../../generic/imageComponents/ImageComponentHead'
import Image from '../../../../../generic/assets/delivery.png'
import { IOrderItem } from '../../../../../modules/API/Drivers/models/kavData'
import { ITableOfTableItem } from '../../../../../modules/API/Defaults/models/tableOfTables'
import { AccentButton } from '../../../../../generic/ui/Button/AccentButton'
import { FormFooter } from '../../../../../generic/ui/FormLayout'
import { getDeliveryActionButtons, hasSelectedOrders } from '../helpers/deliveryActions'
import DeliveryOrderRow from './delivery/DeliveryOrderRow'

interface IProps {
    confirmDeliveryOrder: (id: number) => void,
    selectedDeliveryOrder: IOrderItem[],
    defaultStatuses: ITableOfTableItem[],
    handleSelectOrder: (item: IOrderItem) => void,
    actionList: ITableOfTableItem[]
}

/** Подтверждение доставки: отмечаем теудот и жмём действие — оно уходит по выбранным. */
const DriverModal = ({
    confirmDeliveryOrder, selectedDeliveryOrder,
    handleSelectOrder, actionList
}: IProps) => {
    const isDisabled = !hasSelectedOrders(selectedDeliveryOrder)
    const buttons = getDeliveryActionButtons(actionList)

    return (
        <Panel>
            <ImgContainer>
                <ImageComponentHead img={Image} large />
            </ImgContainer>

            <OrderList>
                {(selectedDeliveryOrder ?? []).map((order) => (
                    <DeliveryOrderRow
                        key={order.OrderID}
                        order={order}
                        onToggle={handleSelectOrder}
                    />
                ))}
            </OrderList>

            <Footer>
                {buttons.map((button) => (
                    <AccentButton
                        key={button.code}
                        type='button'
                        variant={button.variant}
                        fullWidth={false}
                        disabled={isDisabled}
                        onClick={() => confirmDeliveryOrder(button.code)}
                    >
                        {button.label}
                    </AccentButton>
                ))}
            </Footer>
        </Panel>
    )
}

export default DriverModal

const Panel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.875rem;
    direction: rtl;
`

const ImgContainer = styled.div`
    height: 13em;
    width: 100%;
    display: flex;
    justify-content: center;
`

const OrderList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`

/** Закреплён, как в модалках-формах — кнопки видны при прокрутке длинного списка. */
const Footer = styled(FormFooter)`
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.625rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        flex-direction: column;
    }
`
